import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { IconService, IconType } from './dazzle-icon.service';

/**
 * The icon component
 */
@Component({
  standalone: true,
  selector: 'daz-icon',
  styleUrls: ['./dazzle-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [IconService],
  imports: [NgClass],
  template: `<span [ngClass]="{'animate-spin' : spin}" [innerHTML]="svg" [style.height]="size" [style.width]="size">
  </span>`,
})
export class DazzleIconComponent {
  /**
   * The size of the icon. Accepts valid CSS values
   */
  @Input() size: string = '100%';
  /**
   * The name of the icon to render
   */
  @Input() name: any = 'bike';

  @Input() color: string = '#EE3158';
  @Input() spin : boolean = false;

  protected get svg(): SafeHtml {
    let svgContent = this.iconService.getSvgForName(this.name);
    svgContent = svgContent.replaceAll('%color%', this.color);
    return this.sanitizer.bypassSecurityTrustHtml(svgContent);
  }

  constructor(
    private sanitizer: DomSanitizer,
    private iconService: IconService,
  ) {}
}
